import React, { useRef } from "react";



import { Link, useNavigate, useParams } from "react-router-dom";



import "./style.css";



import { useDispatch, useSelector } from "react-redux";



import { setLoaderVisible } from "../../store/slice/navigationSlice";



import { setIsBugDashboard } from "../../store/slice/bugSlice";
import { setIsProjectSetup } from "../../store/slice/setupSlice";



const BreadCrumb = ({ items }) => {



  const navigate = useNavigate();



  const dispatch = useDispatch();



  const { clientId, projectId } = useParams();







  const handleKeyDown = (event, item) => {



    if (event.key === "Enter" || event.key === " ") {



      event.preventDefault();



      navigate(item.link); // Navigate to the link URL using the useNavigate hook



    }



  };





  return (



    <div className="breadcrumb-container">



      <div className="breadcrumb-items">



        {items.map((item, index) => (



          <span key={index} className="breadcrumb-item">



            {index === items.length - 1 ? (



              <span>{item.title}</span>



            ) : (



              <span



                onClick={() => {



                  navigate(item.link, { state: { ...item.state } });



                  handleKeyDown({}, item);



                  dispatch(setIsBugDashboard(false))
                  dispatch(setIsProjectSetup(false))



                }}



                className="link-span"



                onKeyDown={(e) => {



                  if (e.key === 'Enter') {



                    navigate(item.link, { state: { ...item.state } });



                    handleKeyDown(e, item); // Pass event object and item to handleKeyDown



                  }



                }}



                role="link" // Add a role to indicate it's a link for accessibility



                tabIndex={0} // Allow keyboard focus



              >



                {item.title}



              </span>



            )}



          </span>



        ))}



      </div>



    </div>



  );



};







export default React.memo(BreadCrumb);



